
import { API_ENDPOINT } from "../constants";
import { HTTP } from "./http";

export const AccountService = {

    getMasksSMS: (account_id: number) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}accounts/chanels/get-mascara-sms/${account_id}`)
    },

    getBotAccounts: () => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}accounts/v4/root/settings-bot/info/all-accounts`);
    },

    getSubaccounts: (account_id) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}accounts/get-sub-account/${account_id}`);
    },

    getChannels: (account_id) => {
        // return HTTP.get<any, any>(`${API_ENDPOINT.CORE}stadistics/extern/apps-info/${account_id}`);
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}accounts/v3.1/getChannels`, { params:  { account_id } });
    },

    getWABSettings: (account_id) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}accounts/bussisnes-wa/get-general-settings/${account_id}`);
    },

    saveWABSettings: (data) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/bussisnes-wa/edit-general-settings`, data);
    },

    saveSMSSettings: (data) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/chanels/add-sms`, data);
    },

    saveRCSSettings: (data) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/v3.1/vinculate-rcs`, data);
    },

    disconnectSMS: (account_id) => {
        return HTTP.delete<any, any>(`${API_ENDPOINT.CORE}accounts/chanels/remove-sms`, { data: { account_id } });
    },

    disconnectRCS: (account_id) => {
        return HTTP.delete<any, any>(`${API_ENDPOINT.CORE}accounts/v3.1/des-vinculate-rcs`, { data: { account_id } });
    },
    

    getAccountByRoot: () => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}accounts/getAll/root`);
    },
    createAccount: (data) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/addAccount`, data);
    },
    wawebEdit: (data) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/waweb-edit`, data);
    },
    editLicences: (data) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/update-licences`, data);
    },
}